
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8c55b3bc&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PermissionEdit.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PermissionEdit.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8c55b3bc!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PermissionEdit.vue"),
  /* scopeId */
  "data-v-8c55b3bc",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/system/PermissionEdit.vue
// module id = 290
// module chunks = 2 3